import styled from '@emotion/styled';
import { Button, Snackbar } from '@material-ui/core';
import { SnackbarOrigin } from '@material-ui/core/Snackbar';
import { createElement, SyntheticEvent, ComponentType, FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { SnackbarContentProps } from '@material-ui/core/SnackbarContent';
import { TransitionProps } from '@material-ui/core/transitions/transition';

type Props = {
  anchorOrigin?: SnackbarOrigin;
  autoHideDuration?: number;
  message: string | null;
  messageValues?: Record<string, any>;
  action?: string;
  actionValues?: Record<string, any>;
  buttonColor?: 'default' | 'inherit' | 'primary' | 'secondary';
  raw?: boolean;
  onClickAction?: (e: SyntheticEvent<HTMLElement>) => void;
  onRequestClear: (e: SyntheticEvent<HTMLElement>) => void;
  className?: string;
  transition?: ComponentType<TransitionProps>;
  ContentProps?: Partial<SnackbarContentProps>;
};

const FormattedSnackbar: FC<Props> = ({
  anchorOrigin,
  autoHideDuration,
  message,
  messageValues,
  action,
  actionValues,
  buttonColor = 'secondary',
  raw,
  onClickAction,
  onRequestClear,
  className,
  transition,
  ContentProps,
}) => (
  <Snackbar
    anchorOrigin={anchorOrigin}
    autoHideDuration={autoHideDuration}
    open={!!message}
    message={
      message ? raw ? <span>{message}</span> : <FormattedMessage id={message} values={messageValues} /> : undefined
    }
    action={
      action ? (
        <Button color={buttonColor} size="small" onClick={onClickAction}>
          {raw ? <Message>{action}</Message> : <FormattedMessage id={action} values={actionValues} />}
        </Button>
      ) : (
        undefined
      )
    }
    onClose={onRequestClear}
    className={className}
    TransitionComponent={transition}
    ContentProps={ContentProps}
  />
);

const Message = styled('span')({ wordBreak: 'break-all', color: 'inherit' });

export default FormattedSnackbar;
